<template>
  <modal name="simple-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeSimpleDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div style="text-align: center;">
        <p style="font-size: 120%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 90%; padding-bottom: 5px;">作成した履歴書からおすすめの求人をご紹介！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 150%; font-weight: bold;">{{ sub_title }}<span style="font-size: 80%;">の</span>求人<span
              style="font-size: 80%;">を</span>探したい方<span style="color:rgb(246, 11, 38)">必見！</span></p>
          <p style="font-size: 140%;">
            <img src="/static/renew_img/simple_yagish_logo.png" style="width:90%">
          </p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 110%; padding-bottom: 30px;"><span
              style="background: linear-gradient(transparent 60%, #FFCCCC 50%);">{{ sub_title }}の人材紹介サービス</span>に特化した、
            <br><span style="font-weight: bold; font-size: 130%;">「しんぷる{{ sub_title }}」</span>が親身な応援、誠実で的確な
            <br>コンサルティングであなたのキャリアをサポートします！
          </p>
        </div>
        <div>
          <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
            <!--ここにチェックボックス入れる-->
            <p style="padding-bottom: 5px;font-size: 60%;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
              </el-checkbox>
              Simple株式会社の
              <a href="https://simple-hoiku.com/use-policy" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="https://simple-hoiku.com/privacy-policy" class="" id="footer-link-policy"
                target="_blank">個人情報の取扱い</a>
              に同意する
            </p>
            <div style="width: 90%; margin: 0 auto;">
              <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">{{ sub_title }}を希望</p>-->

              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-if="isSimpleSended == false && isAgree == false"
                style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-else-if="isSimpleSended == false && isAgree == true"
                style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
                v-else-if="isSimpleSended == true" style="background-color:#0F9934;border-color:#0F9934;"
                @click="closeSimpleDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

              <p style="font-size: 80%;">※Simple株式会社への登録</p>
            </div>
          </div>
          <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 120%;">ご同意いただいた方には、
              <br><span style="font-weight: bold;">電話もしくはメール</span>にてご連絡いたします。
            </p>
            <p style="font-size: 80%;">※会員登録へのボタンを押した場合、
              <br>規約に同意したとみなします。
            </p>
            <p style="margin: 20px 40px;">（yagishの
              <a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="/privacy" class="" id="footer-link-policy" target="_blank">個人情報保護方針</a>）
              <br>※会員登録へのボタンを押した場合、規約に同意したとみなします。
              <br>※yagishの採用への応募ではありません。
            </p>
          </div>

        </div>

      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div style="text-align: center;">
        <p style="font-size: 120%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 90%; padding-bottom: 5px;">作成した履歴書からおすすめの求人をご紹介！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 150%; font-weight: bold;">{{ sub_title }}<span style="font-size: 80%;">の</span>求人<span
              style="font-size: 80%;">を</span>探したい方<span style="color:rgb(246, 11, 38)">必見！</span></p>
          <p style="font-size: 140%;">
            <img src="/static/renew_img/simple_yagish_logo.png" style="width:90%">
          </p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 110%; padding-bottom: 30px;"><span
              style="background: linear-gradient(transparent 60%, #FFCCCC 50%);">{{ sub_title }}の人材紹介サービス</span>に特化した、
            <br><span style="font-weight: bold; font-size: 130%;">「しんぷる{{ sub_title }}」</span>が親身な応援、誠実で的確な
            <br>コンサルティングであなたのキャリアをサポートします！
          </p>
        </div>
        <div>
          <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
            <!--ここにチェックボックス入れる-->
            <p style="padding-bottom: 5px;font-size: 60%;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
              </el-checkbox>
              Simple株式会社の
              <a href="https://simple-hoiku.com/use-policy" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="https://simple-hoiku.com/privacy-policy" class="" id="footer-link-policy"
                target="_blank">個人情報の取扱い</a>
              に同意する
            </p>
            <div style="width: 90%; margin: 0 auto;">
              <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">{{ sub_title }}を希望</p>-->

              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-if="isSimpleSended == false && isAgree == false"
                style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-else-if="isSimpleSended == false && isAgree == true"
                style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
                v-else-if="isSimpleSended == true" style="background-color:#0F9934;border-color:#0F9934;"
                @click="closeSimpleDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

              <p style="font-size: 80%;">※Simple株式会社への登録</p>
            </div>
          </div>
          <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 120%;">ご同意いただいた方には、
              <br><span style="font-weight: bold;">電話もしくはメール</span>にてご連絡いたします。
            </p>
            <p style="font-size: 80%;">※会員登録へのボタンを押した場合、
              <br>規約に同意したとみなします。
            </p>
            <p style="margin: 20px 40px;">（yagishの
              <a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="/privacy" class="" id="footer-link-policy" target="_blank">個人情報保護方針</a>）
              <br>※会員登録へのボタンを押した場合、規約に同意したとみなします。
              <br>※yagishの採用への応募ではありません。
            </p>
          </div>

        </div>

      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 3">
      <div style="text-align: center;">
        <p style="font-size: 120%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 90%; padding-bottom: 5px;">作成した履歴書からおすすめの求人をご紹介！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 150%; font-weight: bold;">{{ sub_title }}<span style="font-size: 80%;">の</span>求人<span
              style="font-size: 80%;">を</span>探したい方<span style="color:rgb(246, 11, 38)">必見！</span></p>
          <p style="font-size: 140%;">
            <img src="/static/renew_img/simple2_yagish_logo.png" style="width:90%">
          </p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 110%; padding-bottom: 30px;"><span
              style="background: linear-gradient(transparent 60%, #FFCCCC 50%);">{{ sub_title }}の人材紹介サービス</span>に特化した、
            <br><span style="font-weight: bold; font-size: 130%;">「しんぷる{{ sub_title }}」</span>が親身な応援、誠実で的確な
            <br>コンサルティングであなたのキャリアをサポートします！
          </p>
        </div>
        <div>
          <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
            <!--ここにチェックボックス入れる-->
            <p style="padding-bottom: 5px;font-size: 60%;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
              </el-checkbox>
              Simple株式会社の
              <a href="https://simple-hoiku.com/use-policy" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="https://simple-hoiku.com/privacy-policy" class="" id="footer-link-policy"
                target="_blank">個人情報の取扱い</a>
              に同意する
            </p>
            <div style="width: 90%; margin: 0 auto;">
              <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">{{ sub_title }}を希望</p>-->

              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-if="isSimpleSended == false && isAgree == false"
                style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-else-if="isSimpleSended == false && isAgree == true"
                style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
                @click="$eventHub.$emit('send-simple-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">上記の規約に同意して<br>会員登録を希望する</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
                v-else-if="isSimpleSended == true" style="background-color:#0F9934;border-color:#0F9934;"
                @click="closeSimpleDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

              <p style="font-size: 80%;">※Simple株式会社への登録</p>
            </div>
          </div>
          <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 120%;">ご同意いただいた方には、
              <br><span style="font-weight: bold;">電話もしくはメール</span>にてご連絡いたします。
            </p>
            <p style="font-size: 80%;">※会員登録へのボタンを押した場合、
              <br>規約に同意したとみなします。
            </p>
            <p style="margin: 20px 40px;">（yagishの
              <a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="/privacy" class="" id="footer-link-policy" target="_blank">個人情報保護方針</a>）
              <br>※会員登録へのボタンを押した場合、規約に同意したとみなします。
              <br>※yagishの採用への応募ではありません。
            </p>
          </div>

        </div>

      </div>
    </div>

  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSimpleSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      clientId: 'simple_mail',
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      sub_title: '保育士',
      isAgree: false
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openSimpleDialog: function (id, html, permissionType, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('simple-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      if (this.permissionType == 3) {
        this.sub_title = '栄養士'
      } else if (this.permissionType == 1) {
        this.sub_title = '保育士'
      } else if (this.permissionType == 2) {
        this.sub_title = '保育士'
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'simple_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeSimpleDialog: function () {
      if (!this.isSimpleSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }

      this.$modal.hide('simple-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isSimpleSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendSimpleConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'simple_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '1')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendSimple, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSimpleSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-simple-consult', this.sendSimpleConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openSimpleDialog = wrapMittPopupHandler(this, 'openSimpleDialog')
    this.$emitter.on('open-simple-dialog', this._mittGVPopup_openSimpleDialog)
    this.$eventHub.$on('popstate', this.closeSimpleDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-simple-consult', this.sendSimpleConsult)
    this.$emitter.off('open-simple-dialog', this._mittGVPopup_openSimpleDialog)
    this.$eventHub.$off('popstate', this.closeSimpleDialog)
  }
}
</script>
